import angular from 'angular';
import template from './footer.component.html';
import './footer.repository.js';

angular
  .module('Toke')
  .component('appFooter', {
    template,
    bindings: {
      data: '<'
    },
    controller: FooterController
  });

FooterController.$inject = ['footerRepository'];

function FooterController(footerRepository) {

  const vm = this;

  vm.footerData = {};

  vm.$onInit = function () {

    if (vm.data) {
      vm.footerData = vm.data;

    } else {
      footerRepository.getFooter().then(res => {
        vm.footerData = res;

      });
    }
  };
}
